import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

import DynamicElement from "%/dynamic-component-editor/classes/dynamic-element";

// eslint-disable-next-line global-require
const useDynamicComponentEditorStore = (...args) => require("%/dynamic-component-editor/stores/dynamic-component-editor").default(...args);


export default class LayoutDirection extends BaseOption {
  static userInterfaceComponent = {
    label: "Layout Direction",
    component: inspectorTools.RADIO_BAR,
    canSetAsVariable: false,
    props: {
      options: [
        {
          value: "horizontal",
          icon: "arrow-right-thin",
        },
        {
          value: "vertical",
          icon: "arrow-down-thin",
        },
        {
          value: "horizontal-wrap",
          icon: "arrow-turn-left-thin",
        },
      ],
      sideEffect: (value, identifier) => {
        const store = useDynamicComponentEditorStore();
        const [state, breakpoint] = store.activeState.split(":");
        const context = {
          themeMode: store.themeMode,
          themeId: store.themeId,
          breakpoints: store.selectableBreakpoints,
        };

        const element = DynamicElement.get(identifier);
        element?.updateOption("layout-direction", breakpoint, state, value, context);
      },
    },
  };

  static defaultValue = "vertical";
}
